import {
  Text,
  forwardRef,
  Radio,
  RadioProps,
  Image,
  Box,
} from '@chakra-ui/react';

type Props = {
  value: string;
  label: string;
  subtitle?: string | null;
  image: string;
};

export const RadioWithImage = forwardRef(
  ({ label, image, subtitle, ...other }: Props & RadioProps, ref) => (
    <Radio variant="withImage" ref={ref} {...other}>
      <Box>
        <Text>{label}</Text>
        {subtitle ? <Text>{subtitle}</Text> : null}
      </Box>
      <Image src={image} alt={label} maxH="80px" />
    </Radio>
  )
);
